export const email = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
export const wholeNumber = /^\d+$/;
export const ASIN = /^(B\d{2}[A-Z\d]{7}|\d{9}[X\d])$/;
export const UPC = /^[0-9]{12}$/;
export const DECIMAL = /^\d+\.?\d*$/;
export const VALID_DATE = /^(?:(?:\d{4})-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12][0-9]|3[01])|(?:0[469]|11)-(?:0[1-9]|[12][0-9]|30)|02-(?:0[1-9]|1[0-9]|2[0-8]))|(?:\d{4})-02-29-(?:(?:[02468][048]00)|(?:[13579][26]00)|(?:\d{2}(?:[02468][48]|[13579][26]))))$/;
